import React from 'react';
import { keys } from 'lodash';
import { Button } from 'reactstrap';
import DeleteModal from './DeleteModal';

export const BulkDeleteButton = ({
  toggleModal,
  selected,
  url,
  deleteUrl,
  onDeleted,
  isModalOpen,
  buttonProps,
  modalProps,
  readOnly,
  ...props
}) => {
  const numSelected = keys(selected).length;

  if (readOnly) return null;

  return (
    <div {...props}>
      <Button
        onClick={toggleModal}
        disabled={!numSelected}
        color="danger"
        {...buttonProps}
      >
        <span className="fa fa-trash" /> Remove selected{' '}
        {!!numSelected && <span>({numSelected})</span>}
      </Button>
      <DeleteModal
        url={url}
        deleteUrl={deleteUrl}
        onDeleted={onDeleted}
        isOpen={isModalOpen}
        toggle={toggleModal}
        selected={selected}
      />
    </div>
  );
};

export default BulkDeleteButton;



// WEBPACK FOOTER //
// ./src/components/common/Tables/BulkDeleteButton.jsx